import $ from 'jquery';

function initSlider() {
    $('.js-close-slider').slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 1800,
            settings: {
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
           }
        },
        {
            breakpoint: 1200,
            settings: {
                dots: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
           }
        },
        {
            breakpoint: 1024,
            settings: {
                dots: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        },
        {
            breakpoint: 520,
            settings: {
                dots: false,
                slidesToShow: 1.1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        }
        ]
    });
}

$(document).ready(function() {
    initSlider();
    
    $(document).on('click', '.js-vi-button', function() {
        if ($('.b-vi-top-control').is(":visible")) {
            $('.js-close-slider').slick('destroy');
        } else {
            initSlider();
        }
    });
    $(document).on('click', '.b-vi-top-control__version', function() {
        initSlider();
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-close-slider.js